<script lang="ts">
    import { kirbyFetch } from "../../../../api/kirby/api"
    import { languages } from "../../../../configs/config"
    import { currentPage, lang, languageSwitching } from "../../../../store"
    import Searchbar from "./Searchbar.svelte"
    let {
        color,
    }: {
        color: "bright" | "dark"
    } = $props()
    const options: { value: string; label: string }[] = []
    Object.keys(languages).forEach((key) => {
        if (key == $lang) return // @ts-ignore
        options.push({ value: key, label: languages[key] })
    })
    let val = $state($lang)
    let switchSequence = 0

    function toBoolean(value: unknown): boolean {
        return value === true || value === "true" || value === 1 || value === "1"
    }

    function normalizeInternalPath(url: string) {
        return new URL(url, window.location.origin).pathname
    }

    async function getLocalizedPagePath(pageId: string, language: string) {
        const page = await kirbyFetch<Pick<KirbyPage<any>, "url"> & { no_en_version?: boolean }>({
            query: `page("${pageId}")`,
            select: {
                url: true,
                no_en_version: true,
            },
            language,
        })

        if (!page?.url) return null
        if (language === "en" && toBoolean(page.no_en_version)) return null

        return normalizeInternalPath(page.url)
    }

    async function resolveLanguageTarget(targetLanguage: string, currentPath: string) {
        const prefixedPath = currentPath.replace(/^\/(de|en)(?=\/|$)/, `/${targetLanguage}`)
        const activePage = $currentPage

        if (!activePage?.id) {
            return {
                path: prefixedPath,
                preserveSearch: true,
                preserveHash: true,
            }
        }

        const directPath = await getLocalizedPagePath(activePage.id, targetLanguage)
        if (directPath) {
            return {
                path: directPath,
                preserveSearch: true,
                preserveHash: true,
            }
        }

        let parentId = activePage.id
        while (parentId.includes("/")) {
            parentId = parentId.split("/").slice(0, -1).join("/")
            const parentPath = await getLocalizedPagePath(parentId, targetLanguage)
            if (parentPath) {
                return {
                    path: parentPath,
                    preserveSearch: false,
                    preserveHash: false,
                }
            }
        }

        return {
            path: `/${targetLanguage}`,
            preserveSearch: false,
            preserveHash: false,
        }
    }

    $effect(() => {
        if (val === $lang) return

        const sequence = ++switchSequence
        const currentPath = window.location.pathname
        const isHomepage = /^\/(de|en)\/?$/.test(currentPath) || /^\/(de|en)\/home\/?$/.test(currentPath)

        if (isHomepage) {
            window.location.assign(`/${val}`)
            return
        }

        $languageSwitching = true

        void (async () => {
            const url = new URL(window.location.href)
            const target = await resolveLanguageTarget(val, url.pathname)
            if (sequence !== switchSequence) return

            const finalUrl = new URL(url.href)
            finalUrl.pathname = target.path
            if (!target.preserveSearch) finalUrl.search = ""
            if (!target.preserveHash) finalUrl.hash = ""

            window.location.assign(finalUrl.pathname + finalUrl.search + finalUrl.hash)
        })()
    })
</script>

<Searchbar icon="lang" {color} {options} bind:value={val} placeholder="Sprache" />
